import { create } from "zustand";

type State = {
  showPanel: boolean;
};

export const useChatAgentPanelStore = create<State>(() => ({
  showPanel: false,
}));

export const setShowPanel = (value: boolean) => {
  useChatAgentPanelStore.setState({ showPanel: value });
};
